import programArchiveDetail from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/archive/program/:year/:categoryName/:name',
  name: 'programArchiveDetail',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: programArchiveDetail
}

export default route
